import moment from 'moment';
import { RANK_TITLE_MAP } from './enums';

export function isServer() {
  return !(
    typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement
  );
}

export function maybe(exp, d) {
  try {
    const result = exp();
    return result === undefined || result === null ? d : result;
  } catch (err) {
    return d;
  }
}

export function isIntersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1).length > 0;
}

export function insertAt(array, index, ...elements) {
  array.splice(index, 0, ...elements);
}

export function formatDate(dt) {
  return moment(dt).format('YYYY-MM-DD');
}

export function formatPublicDate(dt) {
  return moment(dt).format('DD.MM.YYYY');
}

export function formatPublicDateRange(dt1, dt2) {
  return (
    moment(dt1).format('DD.MM.YYYY') + ' - ' + moment(dt2).format('DD.MM.YYYY')
  );
}

export function formatDateTime(dt) {
  return moment(dt).format('YYYY-MM-DD:HH:mm:ss');
}

export function formatYear(dt) {
  return moment(dt).format('YYYY');
}

export const nexYear = (count = 2) => {
  const d = new Date();
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  return new Date(year + count, month, day);
};

export function deepEqual(object1, object2) {
  const keys1 = Object.keys(object1);
  const keys2 = Object.keys(object2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  for (const key of keys1) {
    const val1 = object1[key];
    const val2 = object2[key];
    const areObjects = isObject(val1) && isObject(val2);
    if (
      (areObjects && !deepEqual(val1, val2)) ||
      (!areObjects && val1 !== val2)
    ) {
      return false;
    }
  }

  return true;
}

export function isObject(object) {
  return object != null && typeof object === 'object';
}

export function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export const toTitleCase = (phrase) =>
  phrase
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('-');

const a = {
  Ё: 'YO',
  Й: 'I',
  Ц: 'TS',
  У: 'U',
  К: 'K',
  Е: 'E',
  Н: 'N',
  Г: 'G',
  Ш: 'SH',
  Щ: 'SCH',
  З: 'Z',
  Х: 'H',
  Ъ: "'",
  ё: 'yo',
  й: 'i',
  ц: 'ts',
  у: 'u',
  к: 'k',
  е: 'e',
  н: 'n',
  г: 'g',
  ш: 'sh',
  щ: 'sch',
  з: 'z',
  х: 'h',
  ъ: "'",
  Ф: 'F',
  Ы: 'I',
  В: 'V',
  А: 'a',
  П: 'P',
  Р: 'R',
  О: 'O',
  Л: 'L',
  Д: 'D',
  Ж: 'ZH',
  Э: 'E',
  ф: 'f',
  ы: 'i',
  в: 'v',
  а: 'a',
  п: 'p',
  р: 'r',
  о: 'o',
  л: 'l',
  д: 'd',
  ж: 'zh',
  э: 'e',
  Я: 'Ya',
  Ч: 'CH',
  С: 'S',
  М: 'M',
  И: 'Y',
  Т: 'T',
  Ь: "'",
  Б: 'B',
  Ю: 'YU',
  я: 'ya',
  ч: 'ch',
  с: 's',
  м: 'm',
  и: 'y',
  т: 't',
  ь: "'",
  б: 'b',
  ю: 'yu',
};

export function transliterate(word) {
  return word
    .split('')
    .map((char) => a[char] || char)
    .join('');
}

export function formatRank(rank) {
  const defaultTitle = 'Відсутні';
  if (!rank) {
    return defaultTitle;
  }
  return RANK_TITLE_MAP[rank] || defaultTitle;
}

export function calculateAge(birthday) {
  const ageDifMs = Date.now() - new Date(birthday).getTime();
  const ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export function getCurrentYear() {
  return new Date().getFullYear();
}

export function prepareParam(pageState) {
  return Object.fromEntries(
    Object.entries(pageState).filter(([, value]) => !!value || value === 0)
  );
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
